import _ from 'lodash';
import config from '../package.json';

import {
  joinPath,
  removeTrailingSlash,
  stringFormatter,
  _get,
} from '../../../utils';
import { getAppModuleConfig } from '../../../selectors/configSelectors';
import { HealthKeeperModuleConfig } from '../types/healthKeeperTypes';

export const getLanguage = (state: any = {}) => {
  return window.location.pathname.split('/').find((s) => !!s) || 'en';
};

export const getAdditionalAccessTokenScope = (state: any) => {
  return getAppModuleConfig<HealthKeeperModuleConfig>(
    state,
    config.profileApiModuleName,
  ).additionalAccessTokenScope;
};

export const getHealthKeeperUrl = (state: {}) => {
  const query = getAppModuleConfig<HealthKeeperModuleConfig>(
    state,
    config.profileApiModuleName,
  ).webViewDeepLink.query;
  return !!query && !!query.url ? query.url : ``;
};

export const getHealthKeeperRequestBody = (state: {}) => {
  const query = getAppModuleConfig<HealthKeeperModuleConfig>(
    state,
    config.profileApiModuleName,
  ).webViewDeepLink.query;
  return !!query && !!query.requestBody ? query.requestBody : ``;
};

export const getHealthKeeperRevampLinkUrl = (state: {}) => {
  const query = getAppModuleConfig<HealthKeeperModuleConfig>(
    state,
    config.profileApiModuleName,
  ).healthKeeperRevampLink.query;
  return !!query && !!query.url ? query.url : ``;
};

export const getOauthPath = (state: {}) => {
  const url = getAppModuleConfig<HealthKeeperModuleConfig>(
    state,
    config.profileApiModuleName,
  ).hkInfo.hkOauthPath;
  return url ? url : ``;
};

export const getAuthenticatePath = (state: {}) => {
  const url = getAppModuleConfig<HealthKeeperModuleConfig>(
    state,
    config.profileApiModuleName,
  ).hkInfo.hkAuthenticatePath;
  return url ? url : ``;
};

export const getGwapaCreateAccountApiUrl = (state: any) => {
  const url = getAppModuleConfig<HealthKeeperModuleConfig>(
    state,
    config.profileApiModuleName,
  ).gwapa.createAccountApiUrl;
  return url ? url : ``;
};

export const getLoginPath = (state: any) => {
  const url = getAppModuleConfig<HealthKeeperModuleConfig>(
    state,
    config.profileApiModuleName,
  ).muleHKLoginPath;
  return url
    ? url
    : `https://az-sit-api.axa.com.hk/api/emma/healthkeeper/login`;
};

export const getRegistrationPath = (state: any) => {
  const url = getAppModuleConfig<HealthKeeperModuleConfig>(
    state,
    config.profileApiModuleName,
  ).muleHKRegistrationPath;
  return url
    ? url
    : `https://az-sit-api.axa.com.hk/api/emma/healthkeeper/registration`;
};
